<template>
  <b-modal
    ref="modal"
    static
    :visible="show"
    :title="modalTitle"
    header-bg-variant="light"
    @hidden="resetForm"
    @close="close"
    @cancel="close"
    @ok.prevent="handleSubmit"
    :ok-disabled="isSubmitting || isDeleting"
    no-close-on-backdrop
    centered
    body-class="px-2 py-5"
    header-class="px-5 py-4"
    footer-class="px-2 py-3"
  >
    <b-form
      @submit.prevent="handleSubmit"
      ref="form"
    >
      <b-col>
        <b-row>
          <b-col cols="6">
            <b-form-group
              class="required-control"
              :state="isValidGroupName"
              :invalid-feedback="groupNameInvalidFeedback"
            >
              <label for="group-name-input">Tên nhóm nhà cung cấp:</label>
              <b-form-input
                id="group-name-input"
                v-model="form.name"
                :state="isValidGroupName"
                required
                placeholder="Nhập tên nhóm nhà cung cấp"
                maxlength="255"
                :disabled="isSubmitting || isDeleting"
                size="sm"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              :state="isValidGroupCode"
              :invalid-feedback="groupCodeInvalidFeedback"
            >
              <label for="group-name-input">Mã nhóm:</label>
              <b-form-input
                id="group-name-input"
                v-model="form.code"
                :state="isValidGroupCode"
                placeholder="Nhập mã nhóm nhà cung cấp"
                maxlength="25"
                :disabled="isSubmitting || isDeleting"
                size="sm"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="isEdit"
              label="Trạng thái:"
              label-for="status-input"
            >
              <b-form-select
                id="status-input"
                v-model="form.status"
                :options="statusOptions"
                :state="isValidStatus"
                :disabled="isSubmitting || isDeleting"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Ghi chú:"
              label-for="description-input"
              :state="isValidNotes"
              :invalid-feedback="notesInvalidFeedback"
              class="mb-0"
            >
              <b-form-textarea
                id="description-input"
                v-model="form.description"
                :state="isValidNotes"
                placeholder="Nhập ghi chú (tùy chọn)"
                rows="5"
                maxlength="500"
                :disabled="isSubmitting || isDeleting"
              ></b-form-textarea>
              <small class="form-text text-muted">
                Tối đa 500 ký tự
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

    </b-form>

    <template #modal-footer="{ cancel }">
      <b-button
        v-if="isEdit"
        variant="danger"
        :disabled="isDeleting"
        @click="handleDelete"
        class="mr-auto"
      >
        <b-spinner
          small
          v-if="isDeleting"
          class="mr-1"
        ></b-spinner>
        Xóa
      </b-button>

      <b-button
        variant="secondary"
        :disabled="isSubmitting || isDeleting"
        @click="cancel()"
      >
        Hủy bỏ
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting || !isFormValid || isDeleting"
        @click="handleSubmit"
      >
        <b-spinner
          small
          v-if="isSubmitting"
          class="mr-1"
        ></b-spinner>
        {{ isEdit ? 'Cập nhật' : 'Thêm mới' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { SupplierGroupService } from './service/supplier-group.service';

export default {
  name: 'SupplierGroupFormModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    supplierGroup: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
      isDeleting: false,
      form: {
        name: '',
        code: '',
        description: '',
        status: '1',
      },
      validationErrors: {
        name: '',
        code: '',
        description: '',
        status: '',
      },
      statusOptions: [
        { value: null, text: '-- Chọn trạng thái --' },
        { value: '1', text: 'Đang giao dịch' },
        { value: '2', text: 'Ngưng giao dịch' },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.isEdit
        ? `Chỉnh sửa nhóm nhà cung cấp: ${this.supplierGroup?.name || ''}`
        : 'Thêm mới nhóm nhà cung cấp';
    },
    isValidGroupName() {
      return this.validationErrors.name ? false : null;
    },
    isValidGroupCode() {
      return this.validationErrors.code ? false : null;
    },
    isValidStatus() {
      return this.validationErrors.status ? false : null;
    },
    isValidNotes() {
      return this.validationErrors.description ? false : null;
    },
    groupNameInvalidFeedback() {
      return this.validationErrors.name;
    },
    groupCodeInvalidFeedback() {
      return this.validationErrors.code;
    },
    notesInvalidFeedback() {
      return this.validationErrors.description;
    },
    isFormValid() {
      return !!this.form.name.trim();
    },
  },
  watch: {
    supplierGroup(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.supplierGroup) {
        this.form = {
          name: this.supplierGroup.name || '',
          code: this.supplierGroup.code || '',
          description: this.supplierGroup.description || '',
          status: this.supplierGroup.status || '1',
        };
      }
    },
    resetForm() {
      this.form = {
        name: '',
        code: '',
        description: '',
        status: '1',
      };
      this.validationErrors = {
        name: '',
        code: '',
        description: '',
        status: '',
      };
    },
    validateForm() {
      this.validationErrors = {
        name: '',
        code: '',
        description: '',
        status: '',
      };

      if (!this.form.name.trim()) {
        this.validationErrors.name =
          'Tên nhóm nhà cung cấp không được để trống';
      }

      if (this.form.description && this.form.description.length > 500) {
        this.validationErrors.description =
          'Ghi chú không được vượt quá 500 ký tự';
      }

      if (!this.form.status) {
        this.validationErrors.status = 'Trạng thái không được để trống';
      }

      return !this.validationErrors.name && !this.validationErrors.description;
    },
    close() {
      this.$emit('close');
    },
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      const formData = {
        name: this.form.name.trim(),
        code: this.form.code.trim() || null,
        description: this.form.description.trim() || null,
      };

      const request = this.isEdit
        ? SupplierGroupService.update(this.supplierGroup.id, formData)
        : SupplierGroupService.create(formData);

      request
        .then((response) => {
          if (response.data.status === 200) {
            const message = this.isEdit
              ? 'Cập nhật nhóm nhà cung cấp thành công!'
              : 'Thêm mới nhóm nhà cung cấp thành công!';

            makeToastSuccess(message);
            this.$emit('supplier-group-saved', response.data.data);
          } else {
            makeToastFaile(
              response.data.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .catch((error) => {
          console.error('Error saving supplier group:', error);

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((key) => {
              if (key in this.validationErrors) {
                this.validationErrors[key] = errors[key];
              }
            });
          } else {
            makeToastFaile(
              error.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    handleDelete() {
      this.showDeleteAlert(this.supplierGroup);
    },

    deleteSupplierGroup(supplierGroup) {
      this.isDeleting = true;

      SupplierGroupService.delete(supplierGroup.id)
        .then((response) => {
          const message =
            response.data.message || 'Xóa nhóm nhà cung cấp thành công!';
          makeToastSuccess(message);
          this.$emit('supplier-group-saved', response.data.data);
        })
        .catch((error) => {
          console.error('Error deleting supplier group:', error);
          const errorMessage =
            error.response?.data?.message ||
            error.message ||
            'Lỗi khi xóa nhóm nhà cung cấp';
          makeToastFaile(errorMessage);
        })
        .finally(() => {
          this.isDeleting = true;
        });
    },

    showDeleteAlert(supplierGroup) {
      this.$swal
        .fire({
          title: 'Xóa nhóm nhà cung cấp!',
          text: `Bạn có chắc muốn xóa nhóm nhà cung cấp "${supplierGroup.name}" này không?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteSupplierGroup(supplierGroup);
          }
        });
    },
  },
};
</script>

<style scoped>
.form-text {
  font-size: 0.875rem;
}

.text-danger {
  font-size: 0.75rem;
}

.required-control label {
  font-weight: 600;
}
</style>
